import { MOBILE_MEDIA_QUERY } from '../utils/misc'
import { useMedia } from './useMedia'

export function useIsMobile() {
  return !useMedia(MOBILE_MEDIA_QUERY.replace('@media ', ''))
}
